// @ts-nocheck
import { useEffect } from "react"
import { motion } from "framer-motion"
import { useNotifications } from "@/lib/hooks/useNotifications"
import { Link } from "react-router-dom"

export function NotificationsClient({ userId }: { userId: string }) {
  const { notifications, loading, unreadCount, markAllRead, markRead } = useNotifications(userId)

  return (
    <div className="max-w-2xl mx-auto">
      <div className="flex items-center justify-between mb-4">
        <h1 className="font-syne font-bold text-xl">Notifications</h1>
        {unreadCount > 0 && (
          <button onClick={markAllRead} className="btn-ghost text-xs">Mark all read</button>
        )}
      </div>

      {loading ? (
        <div className="space-y-2">
          {[1,2,3,4].map(i => <div key={i} className="skeleton h-14 rounded" />)}
        </div>
      ) : notifications.length === 0 ? (
        <div className="panel p-12 text-center">
          <p className="font-syne font-bold text-lg mb-1">All clear</p>
          <p className="text-sm text-muted-fg">No notifications yet.</p>
        </div>
      ) : (
        <div className="space-y-1">
          {notifications.map((n: any, i: number) => (
            <motion.div key={n.id}
              initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.03 }}
              onClick={() => !n.is_read && markRead(n.id)}
              className={`panel p-3.5 cursor-pointer hover:border-border-strong transition-colors ${!n.is_read ? "border-brand/40 bg-brand/5" : ""}`}>
              <div className="flex items-start justify-between gap-2">
                <p className="text-sm leading-snug">{n.title || n.message || n.type}</p>
                {!n.is_read && <span className="w-2 h-2 rounded-full bg-brand flex-shrink-0 mt-1" />}
              </div>
              <p className="text-xs text-muted-fg mt-1">{new Date(n.created_at).toLocaleDateString()}</p>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  )
}
